import { useEffect } from "react";
import { createPortal } from "react-dom";
import wizardStyles from "../styles/AddGifteeWizard.module.css";
import styles from "./GifteeInterestsMoreSheet.module.css";
import { INTEREST_GROUPS } from "../data/interestGroups.js";

export default function GifteeInterestsMoreSheet({
  open,
  interestsDraft,
  onToggleChip,
  onClose,
  onSave,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className={styles.root}>
      <button
        type="button"
        className={styles.backdrop}
        aria-label="Dismiss interests picker"
        onClick={onClose}
      />
      <div
        className={styles.sheet}
        role="dialog"
        aria-modal="true"
        aria-label="Select interests"
      >
        <button
          type="button"
          className={styles.sheetClose}
          onClick={onClose}
          aria-label="Close"
        >
          <i className="fa-solid fa-xmark" aria-hidden />
        </button>
        <div className={styles.sheetBody}>
          <div
            className={wizardStyles.interestsOrderedList}
            style={{ marginTop: 0 }}
          >
            {INTEREST_GROUPS.map((group) => (
              <div key={group.id} className={wizardStyles.interestsSection}>
                <p className={wizardStyles.interestsSectionLabel}>
                  {group.label}
                </p>
                <div className={wizardStyles.interestsChipRow}>
                  {group.chips.map((chip) => {
                    const selected = interestsDraft.has(chip);
                    return (
                      <button
                        key={chip}
                        type="button"
                        className={`${wizardStyles.interestChipPreset} ${
                          selected
                            ? wizardStyles.interestChipPresetSelected
                            : ""
                        }`}
                        onClick={() => onToggleChip(chip)}
                      >
                        {chip}
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.sheetFooter}>
          <button
            type="button"
            className={wizardStyles.customInterestSaveBtn}
            onClick={onSave}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
